import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appReducer from './app/app.reducer';
import authReducer from './auth/auth.reducer';
import accountReducer from './account/account.reducer';
import programsReducer from './programs/programs.reducer';
import { reportsApi } from '@/services/reportsApi';
import { settingsApi } from '@/services/settingsApi';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  account: accountReducer,
  programs: programsReducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
});

const NODE_ENV = import.meta.env.MODE;

export const store = configureStore({
  reducer: rootReducer,
  devTools: NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(reportsApi.middleware, settingsApi.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>;
